import {
  message,
  Space,
  Select,
  Popconfirm,
  Input,
  Row,
  Col,
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  MensajeError,
    ModalItem,
    ButtonItem,
    Form,
    FormItem,
    SelectItem,
    SwitchItem,
    NotificacionPolizas,
    NotificacionMovimientosInventario,
    InputItem,
    DatePickerItem
} from "../../../../Components/Items";
import facturaPdf from "../../../../Pdf/facturaPdf";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import MandarCorreo from "../../Ventas/MandarCorreo/MandarCorreo";
import remisionPdf from "../../../../Pdf/remisionPdf";
import Compress from "../../../../Components/Compress";
import { EditOutlined } from "@ant-design/icons";
import EditarClienteModal from "./EditarClienteModal/EditarClienteModal";
import ticketPdf from "../../../../Pdf/ticketPdf";
import qz from "qz-tray";
import printJS from "print-js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select

class GenerarVentaDePedido extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        pdf: null,
        todasBancos: null,
        todasFormasDePago: null,
        objetoBancos: null,
        objetoFormasDePago: null,
        contado: 1,
        factura: 2,
        modalCorreo: false,
        modalCorreoId: null,
        todasDoctores: [],
        todasPacientes: [],
        objetoDoctores: null,
        objetoPacientes: null,
        cliente: null,
        modalEditarCliente: false,
        objetoRegimenFiscal: null,
        todasRegimenFiscal: null,
        activarRegimenes: false,
        fechaServidor: null,
        facturaFechaAnterior: false,
    };

    // Hora real, tomada del servidor al cargar el modal (no depende del reloj de la computadora)
    horaServidor = () => this.state.fechaServidor ? this.state.fechaServidor.clone() : moment();

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }

    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "pedidos/datosGenerarVenta",
                { pedidoId: this.props.id, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    const fechaServidor = res.data.fechaServidor ? moment(res.data.fechaServidor) : null;
                    // Los del pedido; si no trae, los del cliente.
                    const diasCreditoSugeridos = res.data.diasCredito || res.data.cliente?.diasCredito || 0;
                    this.setState({
                        fechaServidor,
                        facturaFechaAnterior: res.data.facturaFechaAnterior,
                        todasFormasDePago: res.data.formasDePago,
                        todasBancos: res.data.bancosYCajas,
                        todasProyectos: res.data.proyectos,
                        todasUsosDeCFDI: res.data.usosDeCFDI,
                        cliente: res.data.cliente,
                        activarRegimenes: res.data.activarRegimenes,
                        todasRegimenFiscal: res.data.regimenesFiscales,
                        objetoFormasDePago: res.data.formasDePago.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_FormaPago + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),

                        objetoProyectos: res.data.proyectos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),

                        objetoBancos: res.data.bancosYCajas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_UsoCFDI + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoRegimenFiscal: res.data.regimenesFiscales.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.c_RegimenFiscal + " - " + value.descripcion}
                                </Option>
                            );
                        }),
                        contado: res.data.contado,
                        factura: res.data.factura,
                        usoDeCfdiId: res.data.usoDeCfdiId,
                        ventasNoContables: res.data.ventasNoContables,
                        diasCreditoSugeridos,
                    })

                    if (res.data.contado !== 1) {
                        this.formRef.current.setFieldsValue({
                            formaDePagoId: '6125149afe07662acc100d6d'
                        })
                    } else {
                        this.formRef.current.setFieldsValue({
                            formaDePagoId: '6125149afe07662acc100d58'
                        })
                    }

                    if (res.data.predeterminarCXC) {
                        this.formRef.current.setFieldsValue({ cuentasXC: true })
                    }

                    this.formRef.current.setFieldsValue({
                        usoDeCfdiId: res.data.usoDeCfdiId,
                        doctorId: res.data.doctorId,
                        pacienteId: res.data.pacienteId,
                        cirugiaId: res.data.cirugiaId,
                        contado: res.data.contado,
                        diasCredito: diasCreditoSugeridos,
                        proyectoId: res.data.proyectoId,
                        fechaVenta: fechaServidor || moment()
                    })

                    if (res.data.activarRegimenes) {
                        this.formRef.current.setFieldsValue({ regimenFiscalId: res.data.regimenDefaultId })
                    }

                } else {
                    message.warning('No se cargaron bien los datos')
                }
            });
        if (this.props.equipoMedico) {

            await axios
                .post(
                    "ventas/selectDatosParaEquipoMedico",
                    { empresaId: this.props.empresaId },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        this.setState({
                            todasDoctores: res.data.doctores,
                            todasPacientes: res.data.pacientes,
                            todasCirugias: res.data.cirugias,
                            objetoDoctores: res.data.doctores.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                            objetoPacientes: res.data.pacientes.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                            objetoCirugias: res.data.cirugias.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                        });
                    } else {
                        message.error('No se encontraron datos de equipo medico')
                    }
                });

        }
        this.setState({ loading: false });
    }

    onFinishFailed(e) {
        message.error("Revisa que los datos sean correctos");
    }
    onFinish(values) {
        this.setState({ loading: true });
        if (values.contado !== 2) {
            delete values.diasCredito;
        }

        const payload = {
            ...values, 
            pedidoId: this.props.id,
            empresaId: this.props.empresaId,
        };
        axios
            .post(
                "pedidos/generarVentaPedido",
                payload,
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Se ha registrado una venta");
                    if (res.data.respuestaFactura.status === "success") {
                        if (window.registrarMovimiento) {
                            const dataSat = res.data.respuestaFactura.dataSat;
                            const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Rfc + ' - ' + dataSat.Receptor.Nombre + ' )';

                            window.registrarMovimiento({
                                titulo: 'Factura Emitida',
                                mensaje: `${nombreArchivo} - Haga click para descargar`,
                                icono: 2,
                                onClick: () => {
                                    var xmltext = res.data.respuestaFactura.data.cfdi;

                                    const archivos = [
                                        { nombre: `${nombreArchivo}.xml`, contenido: xmltext },
                                    ];

                                    // Generar el PDF y agregarlo al ZIP
                                    const pdf = facturaPdf(res.data);
                                    pdfMake.createPdf(pdf).getBlob((blob) => {
                                        archivos.push({ nombre: `${nombreArchivo}.pdf`, contenido: blob });

                                        // Comprimir los archivos (XML y PDF) en un ZIP y descargarlo
                                        Compress(archivos, nombreArchivo, res?.data?.respuestaFactura?.empresa?.facturaZip);
                                    });
                                },
                            });
                        }

                        NotificacionPolizas(res.data.polizasId);
                        NotificacionMovimientosInventario(res.data.movimientosIds);
                        this.setState({
                            modalCorreo: true,
                            modalCorreoId: res.data.ventaId,
                        });
                    } else {

                      if (window.registrarMovimiento) {

                        const dataSat = res.data.respuestaFactura.dataSat
                        const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'R') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Nombre + ' )'

                        window.registrarMovimiento({
                            titulo: "Remisión Emitida",
                            mensaje: `${nombreArchivo} - Haga click para descargar`,
                            icono: 2,
                            onClick: () => {
                                const pdf = remisionPdf(res.data);

                                pdfMake.createPdf(pdf).download(nombreArchivo + '.pdf');
                            },
                        }
                      )};
         
                        NotificacionPolizas(res.data.polizasId);
                        NotificacionMovimientosInventario(res.data.movimientosIds);
                        this.setState({
                            modalCorreo: true,
                            modalCorreoId: res.data.ventaId,
                        });
                    }
                    if (res.data.respuestaFactura?.empresa?.tikets) {
                        this.printTicket(res.data, res.data.respuestaFactura?.empresa, res.data?.respuestaFactura?.dataSat?.MetodoPago === "PUE");
                    }
                } else if (res.data.success === 1) {
                    MensajeError({
                      message: res.data.errorTimbrado?.titulo || res.data.message || "No se pudo registrar la venta",
                      description: res.data.errorTimbrado?.mensaje || res.data.description,
                      detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
                    });
                } else {
                    message.error("Hubo un error y la venta no se registro");
                }
                this.setState({ loading: false });
            });
    }

    printTicket = async (dataTicket, empresa, contadoCredito) => {
        try {

            if (!this.props.impresoraSeleccionada) {
                throw new Error("No hay impresora seleccionada");
            }

            if (!qz.websocket.isActive()) {
                await qz.websocket.connect();
            }

            const config = await qz.configs.create(this.props.impresoraSeleccionada ? this.props.impresoraSeleccionada : "",
                {
                    encoding: 'Cp1252',
                    scaleContent: false,     // No escalar el contenido del PDF
                    rasterize: true,        // Evita convertir a imagen si no quieres que reduzca resolución
                    density: 300             // Ajusta según tu impresora (203 o 300 dpi típico)
                }
            );


            // const data = ticketEscPos(dataTicket);
            const pdf2 = ticketPdf(dataTicket);
            const base64_1 = await new Promise((resolve) => {
                pdfMake.createPdf(pdf2).getBase64((base64) => resolve(base64));
            });

            let copias = 1;

            if (!contadoCredito && empresa?.impresionTicketsContado > 1) {
                copias = empresa?.impresionTicketsContado;
            }

            if (contadoCredito && empresa?.impresionTicketsCredito > 1) {
                copias = empresa?.impresionTicketsCredito;
            }

            for (let i = 1; i <= copias; i++) {
                await qz.print(config, [
                    {
                        type: 'pixel',
                        format: 'pdf',
                        flavor: 'base64',
                        data: base64_1
                    },
                ]);
            }


            await qz.websocket.disconnect();
            // await qz.print(config, data);

        } catch (err) {
            console.error('Error imprimiendo ticket:', err);
            const pdf2 = ticketPdf(dataTicket);
            pdfMake.createPdf(pdf2).getBlob((blob) => {
                const pdfURL = URL.createObjectURL(blob);

                const ua = navigator.userAgent || "";
                const isAndroid = /Android/i.test(ua);

                // Chrome en iOS aparece como "CriOS"
                const isChromeiOS = /CriOS/i.test(ua);

                // WebView Android común (opcional pero útil)
                const isWebViewAndroid =
                isAndroid && /wv|Version\/\d+\.\d+.*Chrome\/\d+/i.test(ua);

                // ❌ Navegadores que NO pueden con printJS → visor directo
                if (isAndroid || isWebViewAndroid || isChromeiOS) {
                const win = window.open(pdfURL, "_blank");
                if (!win) window.location.href = pdfURL;
                setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
                return;
                }

                // ✅ Navegadores que SÍ pueden (o al menos vale la pena intentar)
                // Intentamos printJS y NO hacemos fallback si falla
                try {
                printJS({
                    printable: pdfURL,
                    type: "pdf",
                    showModal: false,
                });
                } catch (e) {
                // Si falla de inmediato, NO hacemos nada más
                message.error("No se pudo imprimir el ticket automáticamente. Cambie de navegador (por ejemplo, Chrome o Firefox).");
                console.warn("printJS falló inmediatamente:", e);
                }

                // No revocar rápido o rompes printJS
                setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
            });
        }
    }

    cerrarGenerarVentaDePedido() {
        this.props.cerrarGenerarVentaDePedido();
    }

    onChangeContado(value) {
        if (value !== 1) {
            this.formRef.current.setFieldsValue({
                formaDePagoId: '6125149afe07662acc100d6d'
            })
        } else {
            this.formRef.current.setFieldsValue({
                formaDePagoId: '6125149afe07662acc100d58'
            })
        }
    }

    cerrarMandarCorreo() {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
        this.formRef.current.resetFields();
        this.cerrarGenerarVentaDePedido()
    }

    abrirModalEditarCliente() {
        this.setState({ modalEditarCliente: true });
    }

    // Función para cerrar el modal de editar cliente
    cerrarModalEditarCliente() {
        this.setState({ modalEditarCliente: false });
    }

    // Función para obtener el nombre completo del cliente
    obtenerNombreCliente() {
        const cliente = this.state.cliente;

        // Si es persona física, mostrar nombre completo
        if (cliente && cliente.persona === false) {
            return `${cliente.nombre} ${cliente.apellidoPaterno || ''} ${cliente.apellidoMaterno || ''}`.trim();
        } else if (cliente && cliente.persona === true) {
            // Si es empresa, mostrar razón social o nombre comercial
            return cliente.razonSocial || cliente.nombreComercial || cliente.nombre;
        }
    }

    render() {
        return (
            <>
                <ModalItem
                    title="Generar Venta"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarGenerarVentaDePedido.bind(this)}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="generarVentaDePedido"
                        layout
                        width={700}
                        onCancel={this.cerrarGenerarVentaDePedido.bind(this)}
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <FormItem
                            label='Cliente'
                            name="cliente"
                            margin
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                        >
                            <Input.Group compact>
                                <InputItem
                                    value={this.obtenerNombreCliente()}
                                    disabled
                                    placeholder="Cliente"
                                    style={{ width: 'calc(100% - 40px)' }}
                                />
                                <ButtonItem
                                    icon={<EditOutlined />}
                                    onClick={this.abrirModalEditarCliente.bind(this)}
                                    type="primary"
                                    style={{ width: '40px' }}
                                    title="Editar cliente"
                                />
                            </Input.Group>
                        </FormItem>
                        <FormItem
                            required
                            initialValue={2}
                            label='Tipo Venta'
                            name="factura"
                            margin
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                        >
                            <SelectItem
                                onChange={(value) => {
                                    this.formRef.current.setFieldsValue({
                                        usoDeCfdiId: this.state.usoDeCfdiId,
                                        fechaVenta: this.horaServidor()
                                    })
                                    this.setState({ factura: value })
                                }}
                                placeholder='Tipo Venta'
                            >
                                <Option value={2}>Remisión</Option>
                                {this.props.permisoFacturarVentas &&
                                    this.props.certificada && (
                                        <Option value={1}>Factura</Option>
                                    )}
                                {this.state.ventasNoContables && (
                                    <Option value={3}>No Contable</Option>
                                )}
                            </SelectItem>
                        </FormItem>
                        <FormItem
                            label="Fecha:"
                            name="fechaVenta"
                            required
                            margin
                            initialValue={moment()}
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                        >
                            {(() => {
                                const permitirFechaAnterior = this.state.factura === 1 && this.state.facturaFechaAnterior;
                                const fechaMinima = this.horaServidor().subtract(72, "hours");
                                const fechaMaxima = this.horaServidor();
                                const rangoHoras = (inicio, fin) => Array.from({ length: Math.max(fin - inicio, 0) }, (_, i) => inicio + i);
                                return (
                                    <DatePickerItem
                                        disabled={this.state.factura === 1 && !this.state.facturaFechaAnterior}
                                        showTime={permitirFechaAnterior || undefined}
                                        dateFormat={permitirFechaAnterior ? "DD/MM/YYYY HH:mm:ss" : "DD/MM/YYYY"}
                                        disabledDate={permitirFechaAnterior ? (current) => current && (current < fechaMinima.clone().startOf("day") || current > fechaMaxima.clone().endOf("day")) : undefined}
                                        disabledTime={permitirFechaAnterior ? (current) => {
                                            if (!current) return {};
                                            if (current.isSame(fechaMinima, "day")) {
                                                return {
                                                    disabledHours: () => rangoHoras(0, fechaMinima.hour()),
                                                    disabledMinutes: (hora) => hora === fechaMinima.hour() ? rangoHoras(0, fechaMinima.minute()) : [],
                                                    disabledSeconds: (hora, minuto) => hora === fechaMinima.hour() && minuto === fechaMinima.minute() ? rangoHoras(0, fechaMinima.second()) : [],
                                                };
                                            }
                                            if (current.isSame(fechaMaxima, "day")) {
                                                return {
                                                    disabledHours: () => rangoHoras(fechaMaxima.hour() + 1, 24),
                                                    disabledMinutes: (hora) => hora === fechaMaxima.hour() ? rangoHoras(fechaMaxima.minute() + 1, 60) : [],
                                                    disabledSeconds: (hora, minuto) => hora === fechaMaxima.hour() && minuto === fechaMaxima.minute() ? rangoHoras(fechaMaxima.second() + 1, 60) : [],
                                                };
                                            }
                                            return {};
                                        } : undefined}
                                        placeholder="Fecha de Venta"
                                        allowClear={false}
                                    />
                                );
                            })()}
                        </FormItem>
                        {this.state.activarRegimenes && this.state.factura === 1 && (
                            <FormItem
                                label="Regimen Fiscal"
                                name="regimenFiscalId"
                                margin
                                required
                            >
                                <SelectItem placeholder="Regimen Fiscal">
                                    {this.state.objetoRegimenFiscal}
                                </SelectItem>
                            </FormItem>
                        )}
                        <FormItem
                            required
                            name="contado"
                            label="Metodo pago"
                            margin
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                        >
                            <SelectItem
                                onChange={this.onChangeContado.bind(this)}
                            >
                                <Option value={1}>
                                    Contado - PUE : Pago en una sola
                                    exhibición
                                </Option>
                                <Option value={2}>
                                    Crédito - PPD : Pago en
                                    parcialidades o diferido
                                </Option>
                                {/* <Option value={3} disabled>
                                    Crédito con enganche - PPD : Pago en
                                    parcialidades o diferido
                                </Option> */}
                            </SelectItem>
                        </FormItem>
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.contado !== curr.contado}>
                            {({ getFieldValue }) => {
                                const contado = getFieldValue('contado')
                                return (
                                    <FormItem
                                        name="formaDePagoId"
                                        label="Forma Pago"
                                        initialValue="6125149afe07662acc100d58"
                                        margin
                                        required
                                        labelCol={{ span: 8 }}
                                        wrapperCol={{ span: 16 }}
                                    >
                                        <SelectItem disabled={contado !== 1} placeholder="Forma de Pago">
                                            {this.state.objetoFormasDePago}
                                        </SelectItem>
                                    </FormItem>
                                )
                            }}
                        </FormItem>
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.contado !== curr.contado}>
                            {({ getFieldValue }) => {
                                const metodoPago = getFieldValue("contado");
                                return metodoPago === 2 ? (
                                    <FormItem
                                        name="diasCredito"
                                        label="Días Crédito"
                                        margin
                                        required 
                                        labelCol={{ span: 8 }}
                                        wrapperCol={{ span: 16 }}
                                        initialValue={this.state.diasCreditoSugeridos || 0}
                                        rules={[
                                            { required: true, message: "Ingresa los días de crédito" }
                                        ]}
                                    >
                                        <InputItem type="number" placeholder="Días de crédito" />
                                    </FormItem>
                                ) : null;
                            }}
                        </FormItem>
                        <FormItem shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                                const contado = getFieldValue("contado");
                                const cuentasXC = getFieldValue("cuentasXC");
                                if (contado === 1 || contado === 3) {
                                    return (
                                        <>
                                            <FormItem
                                                label="Cuentas XC"
                                                name="cuentasXC"
                                                margin
                                                initialValue={false}
                                                valuePropName="checked"
                                            >
                                                <SwitchItem />
                                            </FormItem>
                                            <FormItem
                                                required={!cuentasXC}
                                                margin
                                                name="bancoId"
                                                label="Banco"
                                            >
                                                <SelectItem placeholder="Banco" disabled={cuentasXC}>
                                                    {this.state.objetoBancos}
                                                </SelectItem>
                                            </FormItem>
                                        </>
                                    );
                                }
                            }}
                        </FormItem>
                        <FormItem shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                                const factura = getFieldValue('factura')
                                if (factura === 1) {
                                    return (
                                        <FormItem
                                            name="usoDeCfdiId"
                                            label="Uso de CFDI"
                                            margin
                                            required
                                            labelCol={{ span: 8 }}
                                            wrapperCol={{ span: 16 }}
                                        >
                                            <SelectItem placeholder="Uso de CFDI">
                                                {this.state.objetoUsosDeCFDI}
                                            </SelectItem>
                                        </FormItem>

                                    )
                                }
                            }}
                        </FormItem>
                        <FormItem
                            label="Proyecto"
                            name="proyectoId"
                            margin
                            required
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                        >
                            <SelectItem
                                placeholder="Proyecto"
                            >
                                {this.state.objetoProyectos}
                            </SelectItem>
                        </FormItem>
                        {this.props.equipoMedico && (
                            <>
                                <FormItem
                                    label="Doctor"
                                    name="doctorId"
                                    margin
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                >
                                    <SelectItem placeholder="Doctor">
                                        {this.state.objetoDoctores}
                                    </SelectItem>
                                </FormItem>
                                <FormItem label="Paciente" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                                    <Row>
                                        <Col span={12}>
                                            <FormItem
                                                name="pacienteId"
                                                margin
                                                noStyle
                                            >
                                                <SelectItem placeholder="Paciente">
                                                    {this.state.objetoPacientes}
                                                </SelectItem>
                                            </FormItem>
                                        </Col>
                                        <Col span={12}>
                                            <FormItem
                                                name="cirugiaId"
                                                margin
                                            >
                                                <SelectItem placeholder="Cirugia">
                                                    {this.state.objetoCirugias}
                                                </SelectItem>
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </FormItem>
                            </>

                        )}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "right",
                                marginTop: 20,
                                marginBottom: 10,
                            }}
                        >
                            <Space>

                                <Popconfirm
                                    title={
                                        (this.state.factura === 1)
                                            ? "Se generara una factura"
                                            : "Se generara una remision"
                                    }
                                    onConfirm={() => this.formRef.current.formRef.current.submit()}
                                    okText="Ok"
                                    cancelText="Cancelar"
                                >
                                    <ButtonItem
                                        type="primary"
                                        style={{ display: "block", margin: "0 0 0 auto" }}
                                    >
                                        Generar Venta
                                    </ButtonItem>
                                </Popconfirm>

                                <Popconfirm>


                                </Popconfirm>
                                <ButtonItem
                                    type="primary"
                                    danger
                                    onClick={this.cerrarGenerarVentaDePedido.bind(this)}
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                >
                                    Regresar
                                </ButtonItem>
                            </Space>
                        </div>
                    </Form>
                </ModalItem>
                <MandarCorreo
                    visible={this.state.modalCorreo}
                    id={this.state.modalCorreoId}
                    cerrarMandarCorreo={this.cerrarMandarCorreo.bind(this)}
                />
                <EditarClienteModal
                    visible={this.state.modalEditarCliente}
                    cliente={this.state.cliente}
                    onCancel={this.cerrarModalEditarCliente.bind(this)}
                    onClienteActualizado={(clienteActualizado) => {
                        this.setState({ cliente: clienteActualizado });
                        this.cerrarModalEditarCliente();
                    }}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        certificada: state.empresa.certificada,
        complementoDetallista: state.empresa.complementoDetallista,
        equipoMedico: state.empresa.equipoMedico,
        impresoraSeleccionada: state.empresa.impresoraSeleccionada,
        permisoFacturarVentas:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "615ce36bf30e81b54183cfaf"
            )?.activado,
    };
};

export default connect(mapStateToProps)(GenerarVentaDePedido);
